import { CONSTANTS } from 'constants/Constants';
import oAxiosInstance from 'redux/interceptors/Interceptors';

const STATES_URL = CONSTANTS.API_URL + 'states';

/**
 * Funcion para tomar todos losDepartamentos de uruguay
 * 
 * 
 * @author Franko Zerpa
 */
export const GetStates = () => {
    return oAxiosInstance.get(STATES_URL).then(oResult => oResult.data)
}
